export default {
  methods: {
    numberFormat: (number) => {
      return parseFloat(number).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    }
  }
}
